/** @jsxImportSource theme-ui */
import React from "react";
import CountUp from "react-countup";
import { Box, Text, Flex, Divider } from "theme-ui";
import PropTypes from "prop-types";
import { colors, typography } from "../../styles/theme";

const Statistics = ({
  number,
  label,
}) => {
  return (
    <Flex sx={statisticsFlex} className="text-container">
      <Box sx={heading}>
        <CountUp
          end={number}
          duration={2}
          enableScrollSpy
          useEasing
          suffix="+"
        />
      </Box>
      <Text sx={{ ...typography.textLg400 }}>{label}</Text>
    </Flex>
  );
};

const StatisticsBox = ({
  statisticsData,
  customStyles,
  dividerCustomStyles,
}) => {
  return (
    <Flex sx={{ ...statisticsBoxFlex, ...customStyles }}>
      {statisticsData.map((stat, index) => (
        <React.Fragment key={`stat-${index}`}>
          <Statistics
            number={stat.number}
            label={stat.label}
          />
          {index !== statisticsData.length - 1 && (
            <Divider sx={dividerCustomStyles ?? dividerStyles} />
          )}
        </React.Fragment>
      ))}
    </Flex>
  );
};

const { statisticsFlex, heading, statisticsBoxFlex, dividerStyles } = {
  statisticsFlex: {
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    "@media screen and (min-width: 1024px)": {
      width: "12rem",
    },
  },
  heading: {
    fontFamily: "Poppins",
    fontSize: "3.188rem",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "3.825rem",
    color: colors.primaryMain,
    mb: "0.5rem",
  },
  statisticsBoxFlex: {
    flexDirection: "row",
    p: "3.75rem 6.25rem",
    backgroundColor: colors.primary100,
    justifyContent: "space-between",
    borderRadius: "20px",
    width: "100%",
    mx: "auto",
    maxWidth: "72rem",
    "@media screen and (max-width: 1172px)": {
      maxWidth: "97%",
    },
    "@media screen and (max-width: 1023px)": {
      p: "3.75rem",
      flexDirection: "column",
      maxWidth: ["20rem", "20rem", "23rem"],
    },
  },
  dividerStyles: {
    "@media screen and (min-width: 1024px)": {
      width: "0.063rem",
      height: "6.25rem",
      backgroundColor: colors.primary200,
    },
    "@media screen and (max-width: 1023px)": {
      color: colors.primary200,
      my: "4rem",
    },
  },
};

StatisticsBox.propTypes = {
  statisticsData: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  isCounter: PropTypes.bool,
  dividerCustomStyles: PropTypes.object,
  customStyles: PropTypes.object,
};
StatisticsBox.defaultProps = {
  statisticsData: [
    {
      number: 30000,
      label: "Customers",
    },
    {
      number: 3000000,
      label: "Employees",
    },
    {
      number: 25,
      label: "Countries",
    },
  ]
};

export default StatisticsBox;
